import { render } from "./projectPage.vue?vue&type=template&id=99a92922"
import script from "./projectPage.vue?vue&type=script&lang=js"
export * from "./projectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__